<template>
  <v-app>
    <v-app-bar color="blue-grey" dense dark app style="box-shadow:none;">
      <v-btn icon @click="goBack">
        <v-icon style="font-size:2rem;">mdi-chevron-left</v-icon>
      </v-btn>
      <v-toolbar-title style="font-size:1rem;padding-left:1.2rem;">账号设置</v-toolbar-title>
    </v-app-bar>
    <v-content style="background:#f2f2f2;">
        <v-container>
            <div v-if="loading" style="margin-top:10rem;">
                <LoadingText />
            </div>
            <div v-else>
                <v-list style="font-size:0.9rem" two-line>
                    <v-list-item style="min-height:55px;max-height:55px;padding-right:0.15rem;position: relative;">
                        <v-list-item-content>
                            <v-list-item-title style="font-size:0.9rem;">
                            消息推送设置
                            </v-list-item-title>
                            <v-list-item-subtitle style="font-size:0.75rem;margin-top:0.2rem;padding-right:1.9rem;">新工单通知、设备异常通知</v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-icon>
                        <v-switch v-model="settInfo.rps" class="sw" color="info" @change="setRecvPushSid" />
                        </v-list-item-icon>
                    </v-list-item>
                </v-list>
            </div>
        </v-container>
    </v-content>
  </v-app>
</template>

<script>
import LoadingText from '../../components/LoadingText'
export default {
  components: { LoadingText },
  props: {
  },
  data() {
    return {
      loading: true,
      settInfo: {
        rps: false
      }
    }
  },
  computed: {
  },
  mounted() {
    var that = this
    that.getUserSetting()
  },
  created() {
  },
  methods: {
    goBack() {
      this.$router.goBack()
    },
    // 获取用户设置
    getUserSetting() {
      var that = this
      that.$api.bz.getUserSetting().then(res => {
        if (!res.success) {
          return;
        }
        var data = res.data
        that.settInfo.rps = data.recv_push_sid === 2
        that.loading = false
      })
    },
    // 消息推送设置
    setRecvPushSid() {
      var that = this
      // console.log('recv_push_sid', that.settInfo.rps);
      that.$api.bz.setRecvPushSid({ rps: that.settInfo.rps ? 2 : 0 }).then(res => {
        // console.log('setRecvPushSid.res', res);
        if (!res.success) {
          that.$toast.warning('设置失败')
          return
        }
        that.$toast.success('设置成功')
      })
    }
  }
}
</script>

<style scoped>
.sw{
    position: absolute;
    top: -0.65rem;
    right: 1rem;
}
</style>

